// 法人情報詳細の定義リストを作成
import React, { memo } from 'react';
import { KeyValue } from '../types/KeyValue';
import {
  CorporateLabelType,
  User1LabelType,
  User2LabelType,
  User3LabelType,
} from '../../ts/types/Corporate';
import { CorporationInfoFormatValue } from '../Common';

interface Props {
  labelData: CorporateLabelType | User1LabelType | User2LabelType | User3LabelType;
  dataArray: KeyValue[] | undefined;
}

const CorporateDataListItems: React.FC<Props> = ({ labelData, dataArray }) => {
  return (
    <>
      {Object.entries(labelData).map(([key, value]) => (
        <dl className="d-flex" key={key}>
          <dt>{value}</dt>
          <dd>{dataArray?.map((item: KeyValue) => item.key === key && CorporationInfoFormatValue(item.value, key))}</dd>
        </dl>
      ))}
    </>
  );
};

export default memo(CorporateDataListItems);
